<div class="flex align-center justify-start gap-10 p-10">
  <app-icon name="ungroup" size="lg" class="material-symbols-outlined icon"></app-icon>
  <h2 mat-dialog-title class="flex-1">You are leaving this website</h2>
</div>
<mat-dialog-content class="dialog-text">
  Clicking this link will direct you to an external site in your browser. Would you like to continue?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button class="error-btn" mat-dialog-close>Cancel</button>
  <button mat-flat-button class="primary-btn" [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</mat-dialog-actions>
